import React, { ReactNode } from 'react';
import { Box, FormControlLabel, FormLabel, Radio, RadioGroup, Stack, SxProps } from '@mui/material';
import { headingFontBold, labelFontSemiBold, vars } from '../../../../Theme';
import Icon from '@mdi/react';

interface IRadioBtnGroupProps {
    options: { key: string; label: string | ReactNode; icon?: { path: string; color?: string } }[];
    onSelect: (key: string) => void;
    label?: string;
    value: string;
    containerSx?: SxProps;
    groupSx?: SxProps;
    horizontal?: boolean;
    border?: boolean;
    disabled?: boolean;
}

const labelSx: SxProps = {
    ...headingFontBold,
    fontSize: '16px',
    color: vars.black,
    fontWeight: 700,
    marginBottom: 1,
    '&.Mui-focused': {
        color: vars.black,
    },
};

export default ({
    options,
    onSelect,
    label,
    value,
    containerSx,
    groupSx,
    horizontal,
    border,
    disabled,
}: IRadioBtnGroupProps) => (
    <Stack sx={containerSx}>
        {label && <FormLabel sx={labelSx}>{label}</FormLabel>}
        <RadioGroup
            aria-disabled={true}
            row={horizontal}
            sx={{
                px: '12px',
                borderRadius: '4px',
                border: border ? `1px solid ${vars.lightGray}` : 'none',
                ...groupSx,
            }}
            value={value}
            onChange={(_ev, newValue) => onSelect(newValue)}
        >
            {options.map(option => (
                <FormControlLabel
                    disabled={disabled}
                    sx={{
                        '& .MuiFormControlLabel-label': {
                            fontSize: '16px',
                            fontFamily: labelFontSemiBold,
                        },
                    }}
                    key={option.key}
                    value={option.key}
                    control={<Radio />}
                    label={
                        <Stack
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                flexFlow: 'nowrap',
                            }}
                        >
                            {option.icon && (
                                <Icon path={option.icon.path} color={option.icon.color} size={1} />
                            )}
                            <Box>{option.label}</Box>
                        </Stack>
                    }
                />
            ))}
        </RadioGroup>
    </Stack>
);
